import PropTypes from 'prop-types';

export const ToolPropTypeFields = {
  mark: PropTypes.any,
  onChange: PropTypes.func,
  onDragStart: PropTypes.func,
  onDragStop: PropTypes.func,
};

export const ToolPropType = PropTypes.shape(ToolPropTypeFields);
